var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3-3h24v24H-3z",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.533 5.52A3.027 3.027 0 0 0 5.52 8.533a3.027 3.027 0 0 0 3.013 3.013 3.027 3.027 0 0 0 3.013-3.013A3.027 3.027 0 0 0 8.533 5.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.49 7.116l-.895-.384a.954.954 0 0 1-.49-.469c-.085-.277-.085-.532 0-.746l.362-.895a.74.74 0 0 0-.106-.916l-1.002-1.001a.741.741 0 0 0-.895-.107l-.916.362a.935.935 0 0 1-1.215-.511l-.383-.874A.709.709 0 0 0 9.246 1H7.82c-.341 0-.64.234-.703.554l-.384.895a.97.97 0 0 1-1.215.511l-.895-.362c-.277-.192-.66-.149-.916.107L2.705 3.706a.741.741 0 0 0-.107.895l.362.916a.935.935 0 0 1-.511 1.215l-.874.384A.709.709 0 0 0 1 7.819v1.427c0 .341.234.64.554.704l.895.383a.97.97 0 0 1 .511 1.215l-.362.895a.715.715 0 0 0 .107.916l1.001 1.002a.741.741 0 0 0 .895.106l.916-.362a.935.935 0 0 1 1.215.511l.384.874c.064.34.362.575.703.575h1.427c.341 0 .64-.234.704-.554l.383-.895a.97.97 0 0 1 1.215-.511l.895.362c.277.192.66.15.916-.106l1.002-1.002a.741.741 0 0 0 .106-.895l-.362-.916a.935.935 0 0 1 .511-1.215l.874-.383a.709.709 0 0 0 .575-.704V7.82c0-.341-.234-.64-.575-.703z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsInactive);
export default __webpack_public_path__ + "static/media/settings-inactive.b9d91cc06a3025fc1c743fc92702b95d.svg";
export { ForwardRef as ReactComponent };